module.exports = __webpack_public_path__ + "img/pe.c96225a3.svg";